import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        cancel: '&',
        employeeDepartmentBudget: '<',
        filter: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ vm.employeeDepartmentBudget.user.displayName }} {{ 'reports.expenses' | translate }} {{ vm.displayPeriod }}</h2>
        </div>
        <div class="modal-body">
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <table class="data01 mt1em" ng-if="!vm.list.loading && vm.list.items.length">
                <thead>
                    <tr>
                        <th>{{ 'reports.Course' | translate }}</th>
                        <th>{{ 'reports.Occurrence' | translate }}</th>
                        <th>{{ 'reports.Used' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                <tr ng-repeat="transaction in vm.list.items">
                    <td>{{ transaction.initiator.occurrence.course.activeI18n.name }}</td>
                    <td>{{ transaction.initiator.occurrence.name }}</td>
                    <td>{{ transaction.amountChanged }} €</td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.cancel()">{{ 'general.Ok' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.cancel()">
                        {{ 'general.Cancel' | translate }}
                    </button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (MomentService, EmployeeBudgetReportResource, ListFactory) {
        this.MomentService = MomentService;
        this.EmployeeBudgetReportResource = EmployeeBudgetReportResource;
        this.ListFactory = ListFactory;
    }

    $onInit () {
        const from = `${this.filter.year}-01-01`;
        const to = `${this.filter.year}-12-31`;
        this.displayPeriod = `${this.MomentService.formatDate(from)} - ${this.MomentService.formatDate(to)}`;


        this.list = this.ListFactory.createWithPagination(this.EmployeeBudgetReportResource.query.bind(this.EmployeeBudgetReportResource));
        this.list.fetch({
            periodStartDate: from,
            periodEndDate: to,
            userId: this.employeeDepartmentBudget.userId,
            expand: 'initiator.occurrence.course.activeI18n'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/expenses/index.js